import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  Button,
  Card,
  Row,
  Col,
  Container,
  Spinner,
  Dropdown,
  DropdownButton,
  Form,
} from "react-bootstrap";
import { FaEllipsisV } from "react-icons/fa";
import Breadcrumbs from "../../Helper/Breadcrumbs";
import { useHistory } from "react-router-dom";
import ConfirmationModel from "../../../shared/ConfirmationModel";
import config from "../../../config";
import { Menu, MenuItem } from "@mui/material";
import PaginationComponent from "./PaginationComponent";
import UnlistedLeadsList from "./UnlistedLeadsList";
import UnlistedLeadForm from "./UnlistedLeadForm";


const OfflineLeadsScreen = () => {
  const history = useHistory();
  const [leads, setLeads] = useState([]);
  const [currentLead, setCurrentLead] = useState(null);
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [view, setView] = useState("offline"); // "offline", "unlisted", "unlisted_form"
  const [editUnlistedLead, setEditUnlistedLead] = useState(null);


  const [filters, setFilters] = useState({
    reportFromDate: "",
    reportToDate: "",
    eventType: "wedding",
    bookingType: "fullday",
  });
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalPages: 1,
  });
  const [isDownloading, setIsDownloading] = useState(false);

  const tokenConfig = {
    headers: { Authorization: `Token ${sessionStorage.getItem("tokenKey")}` },
  };

  const breadcrumbData = [{ title: "Offline Leads", href: "#" }];
  const fetchLeads = () => {
    setLoading(true);
    axios
      .get(`${config.service}/masters/offline_leads/`, {
        params: { page: pagination.page, page_size: pagination.pageSize },
        ...tokenConfig,
      })
      .then(({ data }) => {
        setLeads(data.results);
        setPagination((prev) => ({
          ...prev,
          totalPages: Math.ceil(data.count / prev.pageSize),
        }));
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(fetchLeads, [pagination.page]);

  // <<<<<<<<<<<========CODE BASED ON CREATED ON DATE======>>>>>>>>>>>

  // const handleDownloadReport = () => {
  //   setIsDownloading(true);

  //   axios
  //     .get(`${config.service}/masters/offline_leads/list`, tokenConfig)
  //     .then((response) => {
  //       const filteredLeads = response.data.filter((lead) => {
  //         const reportStartDate = filters.reportFromDate
  //           ? new Date(filters.reportFromDate).toISOString().split("T")[0] // Convert to YYYY-MM-DD
  //           : null;
  //         const reportEndDate = filters.reportToDate
  //           ? new Date(filters.reportToDate).toISOString().split("T")[0] // Convert to YYYY-MM-DD
  //           : null;

  //         if (!lead.created_at) return false; // Skip if created_at is missing

  //         // Extract only the date part (YYYY-MM-DD) from lead.created_at
  //         const [day, month, year] = lead.created_at.split(" ")[0].split("/");
  //         const leadCreatedDate = `${year}-${month}-${day}`; // Format: YYYY-MM-DD

  //         console.log("Lead Created Date:", leadCreatedDate);
  //         console.log("Report Start Date:", reportStartDate);
  //         console.log("Report End Date:", reportEndDate);

  //         const matchesDateFilter =
  //           (!reportStartDate || leadCreatedDate >= reportStartDate) &&
  //           (!reportEndDate || leadCreatedDate <= reportEndDate);

  //         console.log("matchesDateFilter:", matchesDateFilter);
  //         return matchesDateFilter;
  //       });

  //       console.log("Filtered Leads:", filteredLeads);

  //       const leadsToExport =
  //         filters.reportFromDate || filters.reportToDate
  //           ? filteredLeads
  //           : response.data;

  //       console.log("Leads to export:", leadsToExport);

  //       const csvData = [
  //         "KAE Name,Mandapam Name,City,Customer Name,Email,Contact Number,Event Type,Event Subtype,Event Date,Booking Type & Time Slot,Created_at",
  //         ...leadsToExport.map((lead) => {
  //           const eventTypes = lead.lead_events
  //             .map((event) => ` ${event.event_type || ""}`)
  //             .join("\n");
  //           const eventSubtypes = lead.lead_events
  //             .map((event) => ` ${event.event_subtype || ""}`)
  //             .join("\n");
  //           const eventDates = lead.lead_events
  //             .map(
  //               (event) =>
  //                 ` ${
  //                   new Date(event.event_date_from).toISOString().split("T")[0]
  //                 } - ${
  //                   new Date(event.event_date_to).toISOString().split("T")[0]
  //                 }`
  //             )
  //             .join("\n");
  //           const bookingDetails = lead.lead_events
  //             .map(
  //               (event) =>
  //                 `${event.booking_type || ""} (${event.start_time || ""} - ${
  //                   event.end_time || ""
  //                 })`
  //             )
  //             .join("\n");

  //           return [
  //             lead.kae?.user_id?.username || "",
  //             lead.mandap?.mandap_name || "",
  //             lead.mandap?.city_name || "",
  //             lead.customer_name || "",
  //             lead.email || "",
  //             lead.contact_number || "",
  //             `"${eventTypes}"`,
  //             `"${eventSubtypes}"`,
  //             `"${eventDates}"`,
  //             `"${bookingDetails}"`,
  //             lead.created_at ? lead.created_at.split(" ")[0] : "", // Only store the date part
  //           ].join(",");
  //         }),
  //       ].join("\n");

  //       console.log("CSV Data:", csvData);

  //       const blob = new Blob([csvData], { type: "text/csv" });
  //       const url = URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.download = "offline_leads_report.csv";
  //       link.click();
  //       URL.revokeObjectURL(url);
  //     })
  //     .catch((error) =>
  //       console.error("Error fetching or generating report:", error)
  //     )
  //     .finally(() => setIsDownloading(false));
  // };

  // <<<<<<<<<<<========CODE BASED ON CREATED ON DATE======>>>>>>>>>>>

  const parseDate = (dateString) => {
    if (!dateString) return null;
    // Expected format: "18/04/2025 10:43:1744953184"
    const [datePart] = dateString.split(" "); // take '18/04/2025'
    const [day, month, year] = datePart.split("/");
    return `${year}-${month}-${day}`; // returns '2025-04-18'
  };

  // <<<<<<<<<<<========CODE BASED ON Event from Date and To DATE======>>>>>>>>>>>
  const handleDownloadReport = () => {
    setIsDownloading(true);

    axios
      .get(`${config.service}/masters/offline_leads/list`, tokenConfig)
      .then((response) => {
        const filteredLeads = response.data.filter((lead) => {
          if (!lead.lead_events || lead.lead_events.length === 0) return false;

          const reportStartDate = filters.reportFromDate
            ? new Date(filters.reportFromDate).toISOString().split("T")[0] // Convert to YYYY-MM-DD
            : null;
          const reportEndDate = filters.reportToDate
            ? new Date(filters.reportToDate).toISOString().split("T")[0] // Convert to YYYY-MM-DD
            : null;

          // return lead.lead_events.some((event) => {
          //   const eventStartDate = new Date(event.created_at)
          //     .toISOString()
          //     .split("T")[0];

          //   const eventEndDate = new Date(event.created_at)
          //     .toISOString()
          //     .split("T")[0];

          //   console.log(eventStartDate, eventEndDate, "eventStartDate");

          //   return (
          //     (!reportStartDate || eventStartDate >= reportStartDate) &&
          //     (!reportEndDate || eventEndDate <= reportEndDate)
          //   );
          // });

          return lead.lead_events.some((event) => {
            const eventDateStr = parseDate(event?.created_at);
            if (!eventDateStr) return false;

            return (
              (!reportStartDate || eventDateStr >= reportStartDate) &&
              (!reportEndDate || eventDateStr <= reportEndDate)
            );
          });
        });

        console.log("Filtered Leads:", filteredLeads);

        const leadsToExport =
          filters.reportFromDate || filters.reportToDate
            ? filteredLeads
            : response.data;

        console.log("Leads to export:", leadsToExport);

        const csvData = [
          "KAE Name,Mandapam Name,City,Customer Name,Email,Contact Number,Event Type,Event Subtype,Event Date,Booking Type & Time Slot,Created_at",
          ...leadsToExport.map((lead) => {
            const eventTypes = lead.lead_events
              .map((event) => ` ${event.event_type || ""}`)
              .join("\n");
            const eventSubtypes = lead.lead_events
              .map((event) => ` ${event.event_subtype || ""}`)
              .join("\n");
            const eventDates = lead.lead_events
              .map(
                (event) =>
                  ` ${new Date(event.event_date_from).toISOString().split("T")[0]
                  } - ${new Date(event.event_date_to).toISOString().split("T")[0]
                  }`
              )
              .join("\n");
            const bookingDetails = lead.lead_events
              .map(
                (event) =>
                  `${event.booking_type || ""} (${event.start_time || ""} - ${event.end_time || ""
                  })`
              )
              .join("\n");

            return [
              lead.kae?.user_id?.username || "",
              lead.mandap?.mandap_name || "",
              lead.mandap?.city_name || "",
              lead.customer_name || "",
              lead.email || "",
              lead.contact_number || "",
              `"${eventTypes}"`,
              `"${eventSubtypes}"`,
              `"${eventDates}"`,
              `"${bookingDetails}"`,
              lead.created_at ? lead.created_at.split(" ")[0] : "", // Only store the date part
            ].join(",");
          }),
        ].join("\n");

        console.log("CSV Data:", csvData);

        const blob = new Blob([csvData], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "offline_leads_report.csv";
        link.click();
        URL.revokeObjectURL(url);
      })
      .catch((error) =>
        console.error("Error fetching or generating report:", error)
      )
      .finally(() => setIsDownloading(false));
  };

  const handleMenuOpen = (event, lead) => {
    setAnchorEl(event.currentTarget);
    setCurrentLead(lead);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    history.push({
      pathname: "/offlineleadsform",
      state: { id: currentLead.id, editMode: true },
    });
  };

  const handleDeleteConfirmation = (leadId, lead) => {
    handleMenuClose();
    setSelectedLeadId(leadId);
    setSelectedLead(lead);
    setOpenConfirmation(true);
  };

  const handleDelete = async () => {
    try {
      console.log(selectedLead, "selectedLead");

      const leadEvents = selectedLead?.lead_events.map((event) => ({
        event_type: event.event_type,
        event_subtype: event.event_subtype,
        event_date_from: event.event_date_from,
        event_date_to: event.event_date_to,
        start_time: event.start_time,
        end_time: event.end_time,
        booking_type: event.booking_type,
      }));

      let allocatedDates = [];

      for (const event of leadEvents) {
        if (event.booking_type === "full_day") {
          allocatedDates.push(
            {
              timing: "half_day_morning",
              is_blocked: false,
              blocked_by: "agent",
              date: event.event_date_from,
            },
            {
              timing: "half_day_evening",
              is_blocked: false,
              blocked_by: "agent",
              date: event.event_date_from,
            }
          );
        } else {
          allocatedDates.push({
            timing: event.booking_type,
            is_blocked: false,
            blocked_by: "agent",
            date: event.event_date_from,
          });
        }
      }

      const mandapRemovalPayload = {
        allocated_dates: allocatedDates,
        booking_id: selectedLead.booking_id || null,
      };

      console.log("Mandap Removal Payload:", mandapRemovalPayload);

      const mandapId = selectedLead.mandap.id;

      await axios.post(
        `${config.service}/vendor/mandap-allocation/${mandapId}/`,
        mandapRemovalPayload,
        { ...tokenConfig }
      );

      await axios.delete(
        `${config.service}/masters/offline_leads/remove/${selectedLeadId}/`,
        tokenConfig
      );

      setLeads((prevLeads) =>
        prevLeads.filter((lead) => lead.id !== selectedLeadId)
      );

      setOpenConfirmation(false);

      fetchLeads();

      console.log(
        "Lead and associated mandap allocations removed successfully."
      );
    } catch (error) {
      console.error(
        "Error during lead deletion or mandap allocation removal:",
        error
      );
    } finally {
      setOpenConfirmation(false);
    }
  };

  const handleInputChange = (field, value) => {
    if (field === "eventType" && value === "all") {
      setFilters((prevFilters) => ({ ...prevFilters, eventType: "" }));
    } else if (field === "bookingType" && value === "all") {
      setFilters((prevFilters) => ({ ...prevFilters, bookingType: "" }));
    } else {
      setFilters((prevFilters) => ({ ...prevFilters, [field]: value }));
    }
  };

  return (
    <div>
      <Breadcrumbs data={breadcrumbData} />
      <Container>
        <Card>
          <Card.Body className="theme-light">
            <Row className="formBtnsDiv mb-3">
              <Col md={6}>
                <Button
                  variant="primary"
                  onClick={() => history.push("/offlineleadsform")}
                >
                  Create New Lead
                </Button>
                <Button
                  variant="outline-primary"
                  className="ms-2"
                  onClick={() => {
                    if (view === "offline") {
                      setView("unlisted");
                    } else {
                      setView("offline");
                    }
                  }}
                >
                  {view === "offline" ? "Unlisted Venue List" : "Back to Offline Leads"}
                </Button>
              </Col>


              <Col md={6} className="d-flex justify-content-end ">
                <DropdownButton
                  variant="outline-primary"
                  title="Generate Report"
                >
                  <div className="p-3">
                    <Form>
                      <Form.Group controlId="fromDate" className="mb-3">
                        <Form.Label className="fw-bold">
                          Lead Created From
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={filters.reportFromDate}
                          onChange={(e) =>
                            handleInputChange("reportFromDate", e.target.value)
                          }
                        />
                      </Form.Group>

                      <Form.Group controlId="toDate" className="mb-3">
                        <Form.Label className="fw-bold">
                          {" "}
                          Lead Created To
                        </Form.Label>
                        <Form.Control
                          type="date"
                          value={filters.reportToDate}
                          onChange={(e) =>
                            handleInputChange("reportToDate", e.target.value)
                          }
                        />
                      </Form.Group>
                      <Button
                        variant="primary"
                        className="w-100"
                        onClick={handleDownloadReport}
                        disabled={isDownloading}
                      >
                        {isDownloading ? (
                          <>
                            <Spinner animation="border" size="sm" />{" "}
                            Downloading...
                          </>
                        ) : (
                          "Download Report"
                        )}
                      </Button>
                    </Form>
                  </div>
                </DropdownButton>
              </Col>
            </Row>

            {view === "offline" ? (
              loading ? (
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                  <p>Loading leads...</p>
                </div>
              ) : (
                <>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Agent Name</th>
                        <th>Mandapam Name</th>
                        <th>City</th>
                        <th>Customer Name</th>
                        <th>Contact Number</th>
                        <th>Event Type</th>
                        <th>Event Subtype</th>
                        <th>Event Date (From - To)</th>
                        <th>Booking Type & Time Slot</th>
                      </tr>
                    </thead>
                    <tbody>
                      {leads?.length === 0 ? (
                        <tr>
                          <td colSpan="10" className="text-center">
                            No leads found.
                          </td>
                        </tr>
                      ) : (
                        leads.map((lead) => (
                          <tr key={lead.id}>
                            <td>{lead.kae?.user_id?.username || "N/A"}</td>

                            <td>{lead.mandap?.mandap_name || "N/A"}</td>

                            <td>{lead.mandap?.city_name || "N/A"}</td>

                            <td>{lead.customer_name || "N/A"}</td>

                            <td>{lead.contact_number || "N/A"}</td>

                            <td style={{ whiteSpace: "nowrap" }}>
                              {lead.lead_events?.map((event, index) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "10px 0px",
                                    borderBottom:
                                      index === lead.lead_events.length - 1
                                        ? "none"
                                        : "1px solid #ccc",
                                  }}
                                >
                                  <div>{`${event.event_type || "N/A"}`}</div>
                                </div>
                              ))}
                            </td>

                            <td style={{ whiteSpace: "nowrap" }}>
                              {lead.lead_events?.map((event, index) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "10px 0px",
                                    borderBottom:
                                      index === lead.lead_events.length - 1
                                        ? "none"
                                        : "1px solid #ccc",
                                  }}
                                >
                                  <div>{`${event.event_subtype || "N/A"}`}</div>
                                </div>
                              ))}
                            </td>

                            <td style={{ whiteSpace: "nowrap" }}>
                              {lead.lead_events?.map((event, index) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "10px 0px",
                                    borderBottom:
                                      index === lead.lead_events.length - 1
                                        ? "none"
                                        : "1px solid #ccc",
                                  }}
                                >
                                  <div>{`${event.event_date_from} to ${event.event_date_to}`}</div>
                                </div>
                              ))}
                            </td>

                            <td style={{ whiteSpace: "nowrap" }}>
                              {lead.lead_events?.map((event, index) => (
                                <div
                                  key={index}
                                  style={{
                                    padding: "10px 0px",
                                    borderBottom:
                                      index === lead.lead_events.length - 1
                                        ? "none"
                                        : "1px solid #ccc",
                                  }}
                                >
                                  <strong>{`${event.booking_type} (${event.start_time || "N/A"
                                    } - ${event.end_time || "N/A"})`}</strong>
                                </div>
                              ))}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                  <PaginationComponent
                    currentPage={pagination.page}
                    totalPages={pagination.totalPages}
                    onPageChange={(page) =>
                      setPagination((prev) => ({ ...prev, page }))
                    }
                  />
                </>
              )
            ) : view === "unlisted" ? (
              <UnlistedLeadsList
                onEdit={(lead) => {
                  setEditUnlistedLead(lead);
                  setView("unlisted_form");
                }}
              />
            ) : (
              <UnlistedLeadForm
                leadData={editUnlistedLead}
                onCancel={() => setView("unlisted")}
                onSuccess={() => setView("unlisted")}
              />
            )}


            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleEdit}>Edit</MenuItem>
              <MenuItem
                onClick={() =>
                  handleDeleteConfirmation(currentLead.id, currentLead)
                }
              >
                Delete
              </MenuItem>
            </Menu>

            <ConfirmationModel
              operation="delete"
              handleConfirmation={handleDelete}
              val={openConfirmation}
              modelName="Lead"
              onclose={() => setOpenConfirmation(false)}
            />
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default OfflineLeadsScreen;
